import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import CompanyPage from "@/pages/CompanyPage";
import ProductsPage from "@/pages/ProductsPage";
import TemplatesPage from "@/pages/TemplatesPage";
import QuotationsPage from "@/pages/QuotationsPage";
import QuotationBuilderPage from "@/pages/QuotationBuilderPage";
import PipelinePage from "@/pages/PipelinePage";
import TeamPage from "@/pages/TeamPage";
import ProfilePage from "@/pages/ProfilePage";
import PlanPage from "@/pages/PlanPage";
import LegalPage from "@/pages/LegalPage";
import InsightsPage from "@/pages/InsightsPage";
import BackofficePage from "@/pages/BackofficePage";
import Layout from "@/components/Layout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/auth" />;
  // Forzar cambio de contraseña al primer login: solo permitir /app/profile
  if (user.must_change_password && location.pathname !== "/app/profile") {
    return <Navigate to="/app/profile" replace />;
  }
  return children;
}

function RoleRoute({ children, allow }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!allow.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/legal/:doc" element={<LegalPage />} />
          <Route path="/backoffice" element={<BackofficePage />} />
          <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="products" element={<RoleRoute allow={["owner", "administrador"]}><ProductsPage /></RoleRoute>} />
            <Route path="templates" element={<RoleRoute allow={["owner", "administrador"]}><TemplatesPage /></RoleRoute>} />
            <Route path="company" element={<RoleRoute allow={["owner", "administrador"]}><CompanyPage /></RoleRoute>} />
            <Route path="quotations" element={<QuotationsPage />} />
            <Route path="quotations/new" element={<QuotationBuilderPage />} />
            <Route path="quotations/edit/:qid" element={<QuotationBuilderPage />} />
            <Route path="pipeline" element={<PipelinePage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="team" element={<RoleRoute allow={["owner", "administrador", "supervisor"]}><TeamPage /></RoleRoute>} />
            <Route path="plan" element={<PlanPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
